module.exports = __webpack_public_path__ + "img/transfer_nav_night.52d40282.svg";